<template>
    <div class="keyword_box">
        <div class="key_topTit">SMS</div>
        <div class="key_topBtn_group">
            <div class="keyTop_btn" style="color:#EA3796;border-color:#EA3796;" @click="addsms">Create New SMS</div>
        </div>
        <div>
			<el-table
			:data="tableData"
			border
			class="roster_table"
			style="width: 100%">
				<el-table-column
				prop="message"
				align="left"
				label-class-name="roster_th"
				class-name="roster_row"
				label="CONTENT">
				</el-table-column>
				<el-table-column
				prop="name"
				align="left"
				label-class-name="roster_th"
				class-name="roster_row"
				label="PUSH TARGET">
                    <template slot-scope="scope">
                        {{scope.row.venueName}}
                    </template>
				</el-table-column>
				<el-table-column
				prop="createTime"
				align="left"
				label-class-name="roster_th"
				class-name="roster_row"
				label="CREATION TIME">
				</el-table-column>
				<el-table-column
				prop="pushTime"
				align="left"
				label-class-name="roster_th"
				class-name="roster_row"
				label="PUSH TIME">
				</el-table-column>
				<el-table-column
				prop="address"
				align="left"
				label-class-name="roster_th"
				class-name="roster_row"
				label="OPERATION">
					<template slot-scope="scope">
                        <div class="key_delBtn" @click="delsmsDio=true,id=scope.row.pushId">Remove</div>
					</template>
				</el-table-column>
                <template slot="empty">
                    <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
                    <div v-else>-</div>
                </template>
			</el-table>
			<div class="ros_footerPage">
				<el-pagination
					class="my_pageSel"
					layout="prev, pager, next"
					:page-size="10"
                    @current-change='changePage'
                    :current-page.sync='page'
					:total="total">
				</el-pagination>
			</div>
		</div>

        <el-dialog
        title="You sure you want to Remove it?"
        :visible.sync="delsmsDio"
        :modal-append-to-body="false"
        :show-close="false"
        class="delsmsDio_box"
        :close-on-click-modal="false"
        width="740px"
        center>
            <div class="foot_box">
                <el-button @click="delsmsDio=false" class="cardCanBtn">Cancel</el-button>
                <el-button @click="delsms" class="cardConBtn">Confirm</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import api from '../../api/push';
export default {
    data() {
        return {
            delsmsDio:false,
            tableData:[],
            page: 1,
            size: 10,
            total: 0,
            loading:false,
            id:''
        }
    },
    methods: {
        addsms(){
            this.$router.push({path:'/sms'})
        },
        delsms(){
            api.delPush({params:{pushId:this.id},callback:res=>{
                let {code,message,data}=res.data;
                if(code==0){
                    this.getList()
                }else{
                    this.$box.alert('', res.data.message, 'error')
                }
                this.delsmsDio=false
            }})
        },
        changePage(page){
            this.page=page
            this.getList()
        },
        getList(){
            this.loading=true
            let pat={
                pageNum:this.page,
                pageSize:this.size
            }
            api.getPushList({params:pat,callback:res=>{
                this.loading=false
                let {code,message,data}=res.data;
                this.loading2=false;
                if(code==0){
                    this.tableData=data.list;
                    this.total=data.total;
                    this.tableData.forEach(item=>{
                        item.pushTime=Utils.timestampToTimeNew(item.pushTime*1000)
                        item.createTime=Utils.timestampToTimeNew(item.createTime)
                    })
                }else{
                    this.$box.alert('', res.data.message, 'error')
                }
            }})
        }
    },
    mounted() {
        this.getList()
    },
}
</script>

<style lang="scss">
    .keyword_box{
        .key_topTit{
            height:33px;
            font-size:24px;
            font-weight:600;
            color:rgba(255,255,255,1);
            line-height:33px;
            -webkit-text-stroke:1px rgba(255,255,255,1);
            margin-bottom: 40px;
        }
        .key_topBtn_group{
            display: flex;
            .keyTop_btn{
                width: 280px;
                height: 60px;
                line-height: 60px;
                font-size:26px;
                font-weight:600;
                color: #fff;
                margin-right: 30px;
                margin-bottom: 30px;
                border: 2px solid #fff;
                text-align: center;
                border-radius: 2px;
                cursor: pointer;
                .key_numBox{
                    float: right;
                    box-sizing: border-box;
                    text-align: center;
                    width:24px;
                    height:24px;
                    background:rgba(234,55,150,1);
                    color: #fff;
                    font-size:20px;
                    font-weight: 600;
                    line-height: 24px;
                    border-radius: 50%;
                    margin-right: 20px;
                    margin-top: 18px;
                }
            }
        }
		.ros_footerPage{
			display: flex;
			justify-content: center;
        }
        .key_tableBtn_group{
            display: flex;
            justify-content: flex-end;
        }
        .key_delBtn{
            width:100px;
            height:40px;
            background:rgba(21,28,39,1);
            border:1px solid #fff;
            font-size:18px;
            text-align: center;
            line-height: 40px;
            color: #fff;
            cursor: pointer;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/sms/smslist.vue